<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition
    enter-active-class="transition-[max-height,opacity] duration-300 ease-in-out overflow-hidden"
    enter-from-class="max-h-0 opacity-0"
    enter-to-class="max-h-screen opacity-100"
    leave-active-class="transition-[max-height,opacity] duration-300 ease-in-out overflow-hidden"
    leave-from-class="max-h-screen opacity-100"
    leave-to-class="max-h-0 opacity-0"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition>
</template>
